import styled from 'styled-components';

const InfoStyle = styled.div`
	--infoPadding: var(--sp8x);
	--infoBorderRadius: var(--sp2x);
	--hashtagsWrapMarginTop: var(--sp4x);
	--hashtagMarginRight: var(--sp2x);
	--bigDatePadding: var(--sp3x);
	--bigDateMarginTop: var(--sp5x);
	--infoMarginTop: var(--sp8x);
	--infoBlockMarginBottom: var(--sp5x);
	--infoBlockRightMinMaxWidth: var(--sp43x);
	--infoBlockRightSideMarginLeft: var(--sp8x);
	--btnsWrapMarginTop: var(--sp8x);
	--firstButtonMarginRight: var(--sp3x);
	--iconSizes: var(--h5);

	--locationItemMTop: var(--sp1x);

	height: fit-content;
	padding: var(--infoPadding);
	background-color: var(--primaryColor3);
	border-radius: var(--infoBorderRadius);

	&.sticky {
		position: sticky;
		top: 12%;
	}

	.socials-wrap {
		display: flex;
		flex-wrap: wrap;
		margin-top: calc(var(--iconSizes) * -1);

		.link-item {
			margin-right: var(--iconSizes);
			margin-top: var(--iconSizes);

			.imageCont {
				width: var(--iconSizes);
				padding-top: var(--iconSizes);
			}
		}
	}

	.hashtags-wrap {
		display: flex;
		flex-wrap: wrap;
		margin-top: var(--hashtagsWrapMarginTop);

		.hashtag {
			margin-right: var(--hashtagMarginRight);

			&:last-child {
				margin-right: 0;
			}
		}
	}

	.big-date {
		display: inline-flex;
		margin-top: var(--bigDateMarginTop);
		padding: var(--bigDatePadding);
		background-color: var(--secondaryColor4);
		border-radius: var(--sp1-5x);
	}

	.info {
		margin-top: var(--infoMarginTop);

		.website,
		.link {
			word-break: break-all;
		}

		.info-block {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			margin-bottom: var(--infoBlockMarginBottom);

			.info-block-right {
				min-width: var(--infoBlockRightMinMaxWidth);
				max-width: var(--infoBlockRightMinMaxWidth);
				margin-left: var(--infoBlockRightSideMarginLeft);

				.phone {
					display: block;
				}

				.link-wrap {
					width: fit-content;
				}

				&.entrance-fee {
					word-break: break-all;
				}

				.location-item {
					&:not(:first-child) {
						margin-top: var(--locationItemMTop);
					}
				}
			}

			&:last-child {
				margin-bottom: unset;
			}
		}
	}

	.btns-wrap {
		display: flex;
		flex-wrap: wrap;
		margin: 0 calc(var(--firstButtonMarginRight) / -2);
		margin-top: var(--btnsWrapMarginTop);
		margin-bottom: calc(var(--firstButtonMarginRight) / -1);

		.hero-btn {
			margin: 0 calc(var(--firstButtonMarginRight) / 2);
			margin-bottom: var(--firstButtonMarginRight);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--infoPadding: var(--sp6x);
		--hashtagsWrapMarginTop: var(--sp3x);
		--hashtagMarginRight: var(--sp2x);
		--bigDatePadding: var(--sp2x);
		--bigDateMarginTop: var(--sp4x);
		--infoMarginTop: var(--sp7x);
		--infoBlockMarginBottom: var(--sp4x);
		--infoBlockRightMinMaxWidth: var(--sp36x);
		--infoBlockRightSideMarginLeft: var(--sp5x);
		--firstButtonMarginRight: var(--sp3x);
		--btnsWrapMarginTop: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--infoPadding: var(--sp4x);
		--hashtagsWrapMarginTop: var(--sp3x);
		--hashtagMarginRight: var(--sp1-5x);
		--bigDatePadding: var(--sp2x);
		--bigDateMarginTop: var(--sp4x);
		--infoMarginTop: var(--sp6x);
		--infoBlockMarginBottom: var(--sp3x);
		--infoBlockRightMinMaxWidth: var(--sp30x);
		--infoBlockRightSideMarginLeft: var(--sp4x);
		--firstButtonMarginRight: var(--sp2x);
		--btnsWrapMarginTop: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--infoPadding: var(--sp4x);
		--hashtagsWrapMarginTop: var(--sp3x);
		--hashtagMarginRight: var(--sp1-5x);
		--bigDatePadding: var(--sp2x);
		--bigDateMarginTop: var(--sp4x);
		--infoMarginTop: var(--sp6x);
		--infoBlockMarginBottom: var(--sp3x);
		--infoBlockRightMinMaxWidth: var(--sp26x);
		--infoBlockRightSideMarginLeft: var(--sp4x);
		--firstButtonMarginRight: var(--sp2x);
		--btnsWrapMarginTop: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--infoPadding: var(--sp4x);
		--infoBorderRadius: var(--sp2x);
		--hashtagsWrapMarginTop: var(--sp3x);
		--hashtagMarginRight: var(--sp1x);
		--bigDatePadding: var(--sp2x);
		--bigDateMarginTop: var(--sp4x);
		--infoMarginTop: var(--sp6x);
		--infoBlockMarginBottom: var(--sp3x);
		--infoBlockRightMinMaxWidth: var(--sp30x);
		--infoBlockRightSideMarginLeft: var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--btnsWrapMarginTop: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--infoPadding: var(--sp4x);
		--hashtagsWrapMarginTop: var(--sp3x);
		--hashtagMarginRight: var(--sp1x);
		--bigDatePadding: var(--sp2x);
		--bigDateMarginTop: var(--sp4x);
		--infoMarginTop: var(--sp5x);
		--infoBlockMarginBottom: var(--sp3x);
		--infoBlockRightMinMaxWidth: var(--sp16x);
		--infoBlockRightSideMarginLeft: var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--btnsWrapMarginTop: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--infoPadding: var(--sp4x);
		--hashtagsWrapMarginTop: var(--sp2x);
		--hashtagMarginRight: var(--sp1-5x);
		--bigDatePadding: var(--sp2x);
		--bigDateMarginTop: var(--sp3x);
		--infoMarginTop: var(--sp5x);
		--infoBlockMarginBottom: var(--sp4x);
		--infoBlockRightMinMaxWidth: var(--sp44x);
		--infoBlockRightSideMarginLeft: var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--btnsWrapMarginTop: var(--sp5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--infoPadding: var(--sp3x);
		--hashtagsWrapMarginTop: var(--sp2x);
		--hashtagMarginRight: var(--sp1-5x);
		--bigDatePadding: var(--sp2x);
		--bigDateMarginTop: var(--sp3x);
		--infoMarginTop: var(--sp5x);
		--infoBlockMarginBottom: var(--sp4x);
		--infoBlockRightMinMaxWidth: var(--sp24x);
		--infoBlockRightSideMarginLeft: var(--sp2x);
		--firstButtonMarginRight: var(--sp2x);
		--btnsWrapMarginTop: var(--sp5x);

		--locationItemMTop: 4px;
	}
`;

export default InfoStyle;
